'use strict';

var React = require('react');

var SvgFraudProtectPendingMajor = function SvgFraudProtectPendingMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 11.75a.75.75 0 0 0-1.5 0v1.647a1 1 0 0 0 .293.707l.677.677a.75.75 0 1 0 1.06-1.06l-.53-.531v-1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.093 2.915a1.75 1.75 0 0 0-2.186 0l-.317.253a15.25 15.25 0 0 1-3.217 1.976l-.847.384a1.71 1.71 0 0 0-1.01 1.628c.28 6.25 4.38 9.048 5.732 9.802.443.247.97.26 1.423.042a4.5 4.5 0 1 0 5.433-7.17c.202-.806.338-1.69.381-2.655a1.71 1.71 0 0 0-1.002-1.623l-.9-.416a15.249 15.249 0 0 1-3.136-1.938l-.354-.283Zm-2.093 10.585c0 .626.128 1.221.358 1.762-1.472-1.004-4.132-3.455-4.344-8.173-.003-.068.037-.152.133-.195l.846-.385a16.75 16.75 0 0 0 3.534-2.17l.317-.253a.25.25 0 0 1 .312 0l.354.283a16.749 16.749 0 0 0 3.445 2.129l.9.415a.213.213 0 0 1 .131.195 11.927 11.927 0 0 1-.268 2.06 4.504 4.504 0 0 0-5.718 4.333Zm4.5 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  }));
};
SvgFraudProtectPendingMajor.displayName = "FraudProtectPendingMajor";

exports.SvgFraudProtectPendingMajor = SvgFraudProtectPendingMajor;
